module.exports = __webpack_public_path__ + "img/Rooftop 93.66aee805.jpeg";